module.exports = __webpack_public_path__ + "img/zyjy_13.4cbf19bf.png";